import throttle from './throttler';

const stickySuffix = '--sticky';
const staticSuffix = '--static';

const runOnScroll = (selector, element) => {
  const stickyTop = parseInt(window.getComputedStyle(element).top);
  const { top } = element.getBoundingClientRect();
  const toggleClass = top === stickyTop;

  // do not change the state when modal opens
  if (document.body.style.position === 'fixed') {
    return;
  }

  if (window.scrollY < stickyTop) {
    element.classList.remove(
      `${selector}${stickySuffix}`,
      `${selector}${staticSuffix}`,
    );
  } else {
    element.classList.toggle(`${selector}${stickySuffix}`, toggleClass);
    element.classList.toggle(`${selector}${staticSuffix}`, !toggleClass);
  }
};

const determineStickyState = (selector) => {
  const element = document.querySelector(`.${selector}`);

  if (element) {
    window.addEventListener('scroll', () => {
      throttle(runOnScroll(selector, element), 1000);
    });
  }
};

export default determineStickyState;
